var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "delivery__step" },
    [
      _c("MdsComboBox", {
        attrs: {
          label: _vm.translate("scheduler.modal.delivery.type.label"),
          "data-set": _vm.deliveryTypes,
          "selected-items": _vm.deliveryType,
        },
        on: {
          input: function ($event) {
            return _vm.updateDeliveryType($event)
          },
        },
      }),
      _vm._v(" "),
      _vm.deliveryStepInfo.length
        ? _c(_vm.component, {
            tag: "component",
            attrs: {
              label: _vm.translate(
                "scheduler.modal.delivery.destination.label"
              ),
              options: _vm.deliveryDestinations,
              editedFeed: _vm.editedFeed,
            },
            on: {
              input: _vm.updateDeliveryDestination,
              "disable-save-button": function ($event) {
                return _vm.$emit("disable-save-button", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.approvedForFeedDistribution
        ? _c("attestationForm", {
            attrs: { editedFeed: _vm.editedFeed },
            on: {
              "check-accept": _vm.handleAgreementCheck,
              "disable-save-button": function ($event) {
                return _vm.$emit("disable-save-button", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("MdsInput", {
        attrs: {
          required: "",
          error: !!_vm.error.length,
          "error-text": [_vm.error],
          label: _vm.translate("scheduler.modal.source.name.label"),
          placeholder: _vm.translate("scheduler.modal.source.name.placeholder"),
        },
        on: {
          input: function ($event) {
            return _vm.$emit("name", $event)
          },
        },
        model: {
          value: _vm.name,
          callback: function ($$v) {
            _vm.name = $$v
          },
          expression: "name",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "delivery_step_separator" }, [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }